import useQuery from "./useQuery";

export default function usePreviewMode(): { isPreview: boolean } {
  const query = useQuery();

  const isPreview = query.get("isPreview") === "1";

  return { isPreview };
}
